

export function RatingAndReviewd({Instructor, CourseInfo}) {
    return <span className='flex flex-col sm:flex-col justify-between gap-2  mt-3 order-3'>
        <span className='flex flex-col sm:flex-row gap-3 items-center'>
            <span className='flex gap-1 col-end-1'>
                    {[...Array(CourseInfo?.AverageRating)].map((_, index) => (
                                <img
                                    key={index}
                                    className='w-[14px] sm:w-auto'
                                    src={require('../Assets/StarIcon.svg').default}
                                    alt='Star'
                                />
                                ))} 
                {/* <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" />
                <img className='w-[14px] sm:w-auto' src={require('../Assets/StarIcon.svg').default} alt="" /> */}
            </span>
           {!Instructor && CourseInfo?.TotalReviews && <h5 className='text-white text-4xs SemiBold' >Reviewed by {CourseInfo?.TotalReviews} Students</h5>}
        </span>


       {!Instructor && CourseInfo?.AverageRating && <span className='flex self-center sm:self-start gap-1 items-center '>
            <img className='h-5 cursor-pointer ' src={require('../Assets/ThumbIcon.svg').default} alt="" />
            <h5 className='text-base SemiBold text-white'>
                {CourseInfo?.AverageRating * 20}%
            </h5>
        </span>}
    </span>
}

